// One colour ladder for a 1 (most bullish) – 5 (most bearish) rating, shared
// by Yahoo's analyst consensus ("2.0 - Buy") and the AI analysis's Strong Buy …
// Strong Sell call (issue #445), so the two never colour the same word apart.
// Inline styles: the prebuilt Tailwind subset lacks most text-colour utilities.

// "2.0 - Buy" → { value: 2, label: 'Buy' }. null when the string isn't that shape.
export function parseAnalystRating(rating) {
  if (typeof rating !== 'string') return null;
  const match = rating.match(/^([\d.]+)\s*-\s*(.+)$/);
  if (!match) return null;
  const value = parseFloat(match[1]);
  if (!Number.isFinite(value)) return null;
  return { value, label: match[2].trim() };
}

export function ratingScaleStyle(value) {
  if (!Number.isFinite(value)) return { color: '#6b7280' };
  if (value <= 1.5) return { color: '#16a34a', fontWeight: 600 };
  if (value <= 2.5) return { color: '#22c55e' };
  if (value <= 3.5) return { color: '#ca8a04' };
  if (value <= 4.5) return { color: '#ea580c' };
  return { color: '#ef4444' };
}
